import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField, MenuItem, Select, Tooltip, Menu, IconButton, FormControl,} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate, useParams } from "react-router-dom";
import { CiCirclePlus, CiEdit, CiExport } from "react-icons/ci";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Modal, Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { newFilterEntities, postResource,} from "../../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../common/Loader";
import { useSelector } from "react-redux";
import CommonDeleteDialog from "../../common/CommonDelete";
import { MilestoneTaskExport } from "./MilestoneTaskExport";
import { useTheme } from "../../../ThemeContext";
import SubtaskBoard from "../task/SubtaskBoard";
import { openInNewTab } from "../../../utils/openInNewTab";



const AddMilestoneComponent = ({
  onApply,
  onClear,
  onCancel,
  fetchMilestoneTasklist,
}) => {
  const [budgetOpen, setBudgetOpen] = useState(false);
  const [ProjectOpen, setProjectOpen] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      TaskName: "",
      WorkHours: "",
    },
  });

  const [loading, setLoading] = useState(false);
  const { id: milestone_id } = useParams();
  const addMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => inviteMore(data))();
  };

  const inviteMore = async (data) => {
    setLoading(true);
    ////console.log()(data);
    const requestedData = {
      task_list_name: data.TaskName,
      // work_hours: data.WorkHours,
      clone_task_list_id: null,
      // Add other required fields here
    };
    try {
      await postResource( "milestones", "tasklist/add", milestone_id, requestedData );
      fetchMilestoneTasklist();
      ////console.log()("milestoe add response :", response.data);
      reset();
    } 
    catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
      console.error("Error creating Milestone", err);
    } 
    finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    ////console.log()(data);
    const requestedData = {
      task_list_name: data.TaskName,
      // work_hours: data.WorkHours,
      clone_task_list_id: null,
      // Add other required fields here
    };
    try {
      await postResource( "milestones","tasklist/add", milestone_id, requestedData );
      fetchMilestoneTasklist();
      ////console.log()("milestoe add response :", response.data);
      reset();
      onCancel();
    } 
    catch (err) {
      const errorMsg = err.message || err.response.data.message;
      toast.error(errorMsg);
      console.error("Error creating Milestone", err);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset();
  };

  const handleBudgetToggle = () => {
    setBudgetOpen((prev) => !prev);
  };

  const handleProjectToggle = () => {
    setProjectOpen((prev) => !prev);
  };

  const [search, setSearch] = useState("");

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Add New Task List
          </div>
        </button>
      </div>

      <div className="bg-white px-4 py-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row  paddingBtn mb-3">
                <div className="col-12">
                  <label htmlFor="TaskName" className="form-label">
                    Task List <span className="text-rgbr-red"> *</span>
                  </label>
                  <TextField
                    type="text"
                    id="TaskName"
                    placeholder="Enter Task Title"
                    className="form-control"
                    {...control.register("TaskName", {
                      required: "Task list name is required",
                    })}
                  />
                  {/* {errors.TaskName && ( */}
                  <span className="errorMsg">{errors.TaskName?.message}</span>
                  {/* )} */}
                  {/* <button className="R_btn text-rgbr-blue pt-2">
                    Associate Task List Clone from a Project
                  </button> */}
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 w-100 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    onClick={addMore}
                    disabled={loading}
                  >
                    Add more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const MilestoneTasklist = () => {
  const { isDarkMode } = useTheme();
  const { reset } = useForm();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [filter, setFilter] = useState(1);
  const [MilestoneTasklist, setMilestoneTasklist] = useState([]);
  const [boardTasks, setBoardTasks] = useState([]);
  const [viewMode, setViewMode] = useState("table");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const project_id = localStorage.getItem("project_id");
  const [showExportPage, setShowExportPage] = useState(false);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  ////console.log()("login_user_detail in redux state: ", loginUser);
  const { id: login_user_id, role: login_user_role } = loginUser;
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      // Save the id to localStorage
      localStorage.setItem("milestoneId", id);
    }
  }, [id]);


  const onCancel = () => {
    setShowExportPage(false);
  };

  const handleExportPage = () => {
    setShowExportPage(true);
  };

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {/* More options button */}
          <IconButton
            onClick={(event) => {
              event.stopPropagation();
              setSelectedRow(params.row);
              handleMenuOpen(event, params.row);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
    },
    { field: "task_list_id", 
      headerName: "ID", 
      width: 100 
    },
    {
      field: "task_list_name",
      headerName: "Task Lists",
      width: 300,
      renderCell: (params) => (
        <Box sx={{ pl: params.row.isSubtask ? 4 : 0, cursor: "pointer" }}>
          {params.value}
        </Box>
      ),
    },
    {
      field: "added_name",
      headerName: "Added By",
      width: 150,
      renderCell: (params) => params.row.added_name || "-",
    },
    {
      field: "added_at",
      headerName: "Added At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.added_at) return "-";
        try {
          return format(new Date(params.row.added_at), "dd/MM/yyyy hh:mm a");
        } catch {
          return params.row.added_at;
        }
      },
    },
    {
      field: "updatedBy_name",
      headerName: "Updated By",
      width: 150,
      renderCell: (params) => params.row.updatedBy_name || "-",
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.updated_at) return "-";
        try {
          return format(new Date(params.row.updated_at), "dd/MM/yyyy hh:mm a");
        } catch {
          return params.row.updated_at;
        }
      },
    },
  ];
  const {
    handleSubmit: handleEditSubmit,
    reset: editReset,
    register: editRegister,
    formState: { errors: editErrors },
  } = useForm({
    defaultValues: {
      milestone_tasklist_name: selectedRow?.task_list_name,
    },
  });

  useEffect(() => {
    if (selectedRow) {
      editReset({
        milestone_tasklist_name: selectedRow.task_list_name,
      });
    }
  }, [selectedRow]);
  const fetchMilestoneTasklist = async () => {
    setLoading(true);
    const requestedData = {
      view_type_id: filter,
    };
    try {
      const response = await newFilterEntities( "milestones/tasklist", id, requestedData );
      // ////console.log()(response, 'fetchMilestoneTasklist');
      if (response?.data) {
        const data = response.data;
        ////console.log()(data, "Mapped Issues Data");
        setMilestoneTasklist(data);

        // Fetch board tasks if we are in board view or need them
        let allSubtasks = [];
        const taskPromises = data.map(async (taskList) => {
          try {
            const taskResp = await newFilterEntities("milestones/task", taskList.task_list_id, requestedData);
            if (taskResp?.data) {
              return taskResp.data.map(task => {
                let ownerDisplay = "Unassigned";
                if (Array.isArray(task.owners) && task.owners.length > 0) {
                  ownerDisplay = task.owners.length > 1
                    ? `${task.owners[0].name} (+${task.owners.length - 1})`
                    : task.owners[0].name;
                }
                return {
                  ...task,
                  id: task.task_id || task.id,
                  name: task.title,
                  title: task.title,
                  owner: ownerDisplay,
                  owners: task.owners,
                  added_by: task.added_by,
                  current_status_id: task.current_status_id,
                  status_colour: task.status_colour,
                  priority_colour: task.priority_colour,
                  billing_type: task.billing_type,
                  status: task.current_status_name || "N/A",
                  current_status_name: task.current_status_name || "Open",
                  startDate: task.start_date ? task.start_date : null,
                  dueDate: task.end_date ? task.end_date : null,
                  duration: task.estimated_hours ? `${task.estimated_hours} hrs` : "N/A",
                  priority: task.priority_name,
                  priority_name: task.priority_name,
                  project_id: task.project_id,
                  milestone_id: task.milestone_id,
                  task_list_id: taskList.task_list_id,
                  log_hours: task.timelogs,
                  isSubtask: true,
                  parentId: `T${taskList.task_list_id}`,
                  task_list_name: taskList.task_list_name,
                };
              });
            }
          } 
          catch (e) {
            console.error(`Failed to fetch tasks for tasklist ${taskList.task_list_id}`);
          }
          return [];
        });

        const resolvedTasks = await Promise.all(taskPromises);
        setBoardTasks(resolvedTasks.flat());

      } 
      else {
        console.error("No issues found in the response.");
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMilestoneTasklist();
  }, [filter, viewMode]);
  useEffect(() => {
    // console.log("milestone_task_list :",MilestoneTasklist);
    
  },[])

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    //console.log("milestone_row :", row);

    setSelectedTask(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleClone = () => {
    ////console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    ////console.log()(` milestone_task_list View task: ${selectedTask}`);
    navigate(
      `/projects/projectDetail/${selectedTask?.project_id}/milestone/MilestoneDetail/${selectedTask?.milestone_id}/MilestoneSubTasklist/${selectedTask?.task_list_id}`,
    );
    handleMenuClose();
  };
  const handleViewDitailstab = () => {
    ////console.log()(` milestone_task_list View task on new tab: ${selectedTask}`);
    const path = `/projects/projectDetail/${selectedTask?.project_id}/milestone/MilestoneDetail/${selectedTask?.milestone_id}/MilestoneSubTasklist/${selectedTask?.task_list_id}`;
    openInNewTab(path);

    handleMenuClose();
  };

  const handleCopylink = () => {
    ////console.log()(`Copy task: ${selectedTask?.task_list_id}`);
    handleMenuClose();
  };

  const filterOptions = {
    predefined: [{ label: "All Task Lists", value: 1 }],
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    let filteredProjects;
    switch (value) {
      case "completed":
        filteredProjects = MilestoneTasklist.filter(
          (project) => project.completion === 100,
        );
        break;
      case "recent":
        filteredProjects = MilestoneTasklist; // Modify this to sort/filter based on recent access logic
        break;
      default:
        filteredProjects = MilestoneTasklist;
    }

    setMilestoneTasklist(filteredProjects);
  };

  // Handle row click
  const onEditSubmit = async (data) => {
    setEditLoading(true);
    const requestData = {
      task_list_name: data.milestone_tasklist_name,
    };
    try {
      const response = await postResource(
        "milestones",
        "tasklist/update",
        selectedRow?.task_list_id,
        requestData,
      );
      toast.success(response.message);
      setShowEditModal(false);
      fetchMilestoneTasklist();
    } 
    catch (error) {
      toast.error(error.message || error.response?.data?.message);
    } 
    finally {
      setEditLoading(false);
    }
  };

  const handleRowClick = (params) => {
    //console.log("params_value_mile :", params);

    const { task_list_id } = params.row;
    navigate(
      `/projects/projectDetail/${params.row?.project_id}/milestone/MilestoneDetail/${params.row?.milestone_id}/MilestoneSubTasklist/${task_list_id}`,
    );
  };
  const handleCloseModal = () => {
    setShowEditModal(false);
    setSelectedRow(null);
  };

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <AddMilestoneComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            onApply={(filters) =>
              setMilestoneTasklist(/* filtered data based on `filters` */)
            }
            fetchMilestoneTasklist={fetchMilestoneTasklist}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showExportPage}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <MilestoneTaskExport onCancel={onCancel} MilestoneTasklist={MilestoneTasklist} />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div className="py-3">
        {/* <div className="d-flex justify-content-between pb-2">
          <FormControl className="pb-2"> */}
        <Box
          className="d-flex justify-content-between align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "10px 14px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex align-items-center">
            <FormControl>
              <Select value={filter} onChange={handleFilterChange} size="small">
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="d-flex align-items-center d-none d-sm-flex">
              <Tooltip title="Table View">
                <Button
                  onClick={() => setViewMode("table")}
                  sx={{
                    backgroundColor: viewMode === "table" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "table" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "table" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    minWidth: "75px",
                    padding: "0 10px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: '10px',
                    textTransform: "none",
                    marginBottom:"1px",
                    marginLeft:"10px",
                    "&:hover": {
                      backgroundColor: viewMode === "table" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </Button>
              </Tooltip>

              <Tooltip title="Board View">
                <Button
                  onClick={() => setViewMode("board")}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    minWidth: "75px",
                    padding: "0 10px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    textTransform: "none",
                    marginBottom:"1px",
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </Button>
              </Tooltip>
            </div>
          </div>

          <div className="d-flex align-items-center">
            {/* <SearchBar
              placeholder="Search tasklist"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            /> */}
            {login_user_role !== "CLIENT" && (
              <Tooltip title="Add New Task List">
                <IconButton
                  onClick={handleShowProject}
                  sx={{
                     backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      margin:"0 10px 0 12px",
                      width: "38px",
                      height: "38px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                    me: 2,
                  }}
                >
                  <CiCirclePlus className="pro-icon-s text-rgbr-blue" />
                </IconButton>
              </Tooltip>
            )}
            {(login_user_role === "MANAGER" || login_user_role === "ADMIN") && (
              <Tooltip title="Export">
                <IconButton
                  className="ms-3"
                  onClick={handleExportPage}
                  sx={{
                        backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      margin:"0 10px 0 12px",
                      width: "38px",
                      height: "38px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                    me: 2,
                  }}
                >
                  <CiExport className="pro-icon-s text-rgbr-blue" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        {/* </div> */}
        </Box>
        {loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <Box style={{ width: "100%" }}>
            {viewMode === "table" ? (
              <DataGrid
                rows={MilestoneTasklist}
                columns={columns}
                getRowId={(row) => row.task_list_id} // Use a unique key for each row
                disableSelectionOnClick
                pagination
                paginationModel={pagination}
                onPaginationModelChange={setPagination}
                pageSizeOptions={[10, 20, 30, 40]}
                onRowClick={handleRowClick}
                autoHeight
              />
            ) : (
              <SubtaskBoard
                numericId={id}
                allTasks={boardTasks}
                onRefresh={fetchMilestoneTasklist}
                loading={loading}
                onOpenTask={(task) => {
                  const pid = task.project_id || project_id;
                  const mid = task.milestone_id || id;
                  const tlid = task.task_list_id;
                  const tid = task.id || task.task_id;
                  navigate(
                    `/projects/projectDetail/${pid}/milestone/MilestoneDetail/${mid}/MilestoneSubTasklist/${tlid}/TasklistDetail/${tid}`
                  );
                }}
              />
            )}

            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleView}>
                <CiViewList className="me-2" color="blue" />
                View Details
              </MenuItem>
              <MenuItem onClick={handleViewDitailstab}>
                <CiViewList className="me-2" color="blue" />
                View Details in New Tab
              </MenuItem>
              {selectedTask?.task_list_id &&
                (["ADMIN", "MANAGER"].includes(login_user_role) ||
                  MilestoneTasklist.find(
                    (milestone) =>
                      milestone.task_list_id === selectedTask?.task_list_id,
                  )?.added_by === login_user_id) && (
                  <>
                    <CommonDeleteDialog
                      name="Tasklist"
                      statusName={
                        MilestoneTasklist.find(
                          (list) =>
                            list.task_list_id === selectedTask?.task_list_id,
                        )?.task_list_name
                      }
                      url="tasklist/delete"
                      id={selectedTask?.task_list_id}
                      refetchList={fetchMilestoneTasklist}
                      handleListClose={handleMenuClose}
                    />

                    <MenuItem
                      onClick={() => {
                        setShowEditModal(true);
                        handleMenuClose();
                      }}
                    >
                      <CiEdit className="me-2" color="blue" />
                      Edit Tasklist
                    </MenuItem>
                  </>
                )}
            </Menu>
          </Box>
        )}
      </div>

      <Modal show={showEditModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Tasklist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="edit-milestone-form"
            onSubmit={handleEditSubmit(onEditSubmit)}
          >
            {/* Milestone Name */}
            <div className="mb-3">
              <label htmlFor="milestone_tasklist_name" className="form-label">
                Tasklist Name <span className="errorMsg">*</span>
              </label>
              <TextField
                type="text"
                placeholder="Enter milestone name"
                className="form-control"
                {...editRegister("milestone_tasklist_name", {
                  required: "Milestone name is required",
                })}
              />
              {editErrors.milestone_tasklist_name && (
                <span className="text-danger">
                  {editErrors.milestone_tasklist_name.message}
                </span>
              )}
            </div>
          </form>
        </Modal.Body>
        
        <Modal.Footer>
          <button
            type="button"
            className="cancel_btn"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="edit-milestone-form"
            className="add_btn"
            disabled={editLoading}
          >
            {editLoading ? <BtnLoader /> : "Update"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MilestoneTasklist;
